module.exports = __webpack_public_path__ + "static/media/FRAX.332f9daf.svg";